import { createStandardAction } from 'typesafe-actions';

export const updateChaptersVisibility = createStandardAction(
  'chapters/TOGGLE_VISIBILITY'
)<boolean | undefined>();
